export enum OrderItemReturnPolicy {
  FullRefund,
  SiteCreditOnly,
  NotEligibleForReturn,
  ExtendedHolidays,
  FullRefundMarkdown,
  SiteCreditOnlyMarkdown,
  FullRefundPromo
}
